<script setup lang="ts">
  import type { QuotedPlanVm } from '~/models/quoting/QuotedPlan'

  defineProps<{
    quote: QuotedPlanVm
    minimal: boolean
    stacked: boolean
  }>()

  const { getQuoteCardEventProps } = QuoteAnalytics.use()
</script>

<template>
  <PxComparePlanControl
    :medicare-id="quote.medicareId"
    :event-data="getQuoteCardEventProps('add-to-compare', quote)"
    :minimal="minimal"
    :stacked="stacked"
  />
  <PxSavedPlanControl
    :medicare-id="quote.medicareId"
    :year="quote.details.year!"
    :event-data="getQuoteCardEventProps('save-this-plan', quote)"
    :minimal="minimal"
    :stacked="stacked"
  />
</template>

<style scoped></style>
